import './index.scss'
import { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { faHome, faUser, faBars } from '@fortawesome/free-solid-svg-icons'
import { NavLink } from 'react-router-dom'

const Sidebar = () => {
  const [showNav, setShowNav] = useState(false)

  // Toggle the sidebar visibility
  const toggleNav = () => {
    setShowNav(!showNav)
  }

  // Apply class to body when the sidebar is open
  useEffect(() => {
    if (showNav) {
      document.body.classList.add('sidebar-open-content')
    } else {
      document.body.classList.remove('sidebar-open-content')
    }
  }, [showNav])

  return (
    <div className={`sidebar ${showNav ? 'sidebar-open' : ''}`}>
      {/* Hamburger Icon to open the sidebar */}

      {/* Sidebar content */}
      <nav className={showNav ? 'mobile-show' : ''}>
        <NavLink exact="true" activeclassname="active" to="/">
          <FontAwesomeIcon icon={faHome} color="#4d4d4e" />
        </NavLink>
        <NavLink
          activeclassname="active"
          className="about-link"
          to="/Portfolio"
        >
          <FontAwesomeIcon icon={faUser} color="#4d4d4e" />
        </NavLink>
      </nav>

      {/* LinkedIn Icon */}
      <ul>
        <li>
          <a
            href="https://www.linkedin.com/in/hadi-dabbur-496276254/"
            target="_blank"
            rel="noreferrer"
          >
            <FontAwesomeIcon
              icon={faLinkedin}
              color="#4d4d4e"
              className="anchor-icon"
              fontSize={55}
            />
          </a>
        </li>
      </ul>
    </div>
  )
}

export default Sidebar
